<template>
  <div>
    <el-dialog :close-on-click-modal="false"
        title="活动数据"
        :visible.sync="addsign"
        :before-close="addProClose"
        width="123rem"
        center
      >
        <el-divider></el-divider>
        <div class="title">
            <div> <span>报名人数：</span><span>{{act_people}}</span> 人</div>
            <div class="filter-row">
              <span class="filter-label">状态</span>
              <el-select v-model="data.state" placeholder="请选择状态" style="width: 14rem" @change="onStateChange">
                <el-option label="全部" value="0"></el-option>
                <el-option label="待支付" value="1"></el-option>
                <el-option label="已支付" value="2"></el-option>
                <el-option label="已退款" value="3"></el-option>
              </el-select>
              <el-button type="primary" class="export-btn" @click="exportList">导出</el-button>
            </div>
        </div>
        <div class="table">
          <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
            <el-table-column prop="createtime"  label="报名时间" ></el-table-column>
            <el-table-column prop="activity_name" label="活动名称" ></el-table-column>
            <el-table-column  label="手机号" prop="phone" ></el-table-column>
            <el-table-column  prop="name"  label="用户名" ></el-table-column>
            <el-table-column  label="来源" >
              <template slot-scope="scope">
                  <span>{{scope.row.from=='1'?'微商城':'小程序'}}</span>
              </template>
            </el-table-column>
            <el-table-column  label="状态" >
              <template slot-scope="scope">
                  <span>{{scope.row.state=='1'?'待支付':scope.row.state=='2'?'支付成功':scope.row.state=='3'?'已退款':'已使用'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" >
              <template slot-scope="scope">
                <span class="tab_detail"  @click="openAppli(scope.row)">详情</span>
                <!-- <span class="tab_detail" style="margin-left:2rem;" @click="returnOrder">退票</span> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" @current-change="currenchange" :page-size="data.limit" :total="total" :current-page="data.page"  ></el-pagination>
          </div>
        </div>
        <!-- <div class="button">
            <div>清空</div>
            <div>确认保存</div>
        </div> -->
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
        title="报名表"
        :visible.sync="appflow"
        :before-close="appProClose"
        width="100rem"
        center
      >
        <el-divider></el-divider>
        <div class="table">
            <div>
              <div v-for="(item,index) in arr" :key="index">
                <div class="box" v-if="item.question_type=='1'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div class="box_radio">
                      <div v-for="(itm,idx) in item.option" :key="idx">
                        <el-radio disabled v-model="item.choice" :label="itm.option_name">{{itm.option_name}}</el-radio>
                      </div>
                    </div>
                </div>
                <div class="box" v-if="item.question_type=='2'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div class="box_radio checkbox">
                      <div >
                        <!-- <el-checkbox disabled v-model="checked" >{{itm.option_name}}</el-checkbox> -->
                        <el-checkbox-group v-model="item.splice" v-for="(itm,idx) in item.option" :key="idx">
                          <el-checkbox disabled :label="itm.option_name">{{itm.option_name}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <!-- <div><el-checkbox v-model="checked">备选项</el-checkbox></div> -->
                    </div>
                </div>
                <div class="box" v-if="item.question_type=='3'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div class="box_select">
                      <div>
                        <el-select v-model="item.choice" placeholder="选项" disabled>
                          
                        </el-select>
                      </div>
                    </div>
                </div>
                <!-- <div class="box" v-if="item.id=='4'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div class="box_select">
                      <div class="slect_flex">
                        <el-select v-model="itm.option_name" placeholder="选项" disabled v-for="(itm,i) in item.option" :key="i">
                        </el-select>
                      </div>
                    </div>
                </div> -->
                <div class="box boxwhite" v-if="item.question_type=='5'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div class="box_textares">
                      {{item.choice}}
                    </div>
                </div>
                <div class="box boxwhite" v-if="item.question_type=='6'" >
                    <div class="box_title">
                      <span> <span>*</span>{{index+1}}：</span>
                      <span>{{item.question_name}}</span>
                    </div>
                    <div v-for="(itm,idx) in item.splice" :key="idx">
                      <span class="textarea_title">填空{{idx+1}}</span>
                      <div class="box_textares">
                        {{itm}}
                      </div>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import {MessageBox, Message} from 'element-ui'
export default {
  data(){
    return{
      radio:'1',
      appflow:false,
      addsign:false,
      tableData:[
        {}
      ],
      arr:[
      ],
      total:0,
      value:'',
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        data:{
          actid:'',
          state: '2',
          limit:8,
          page:1
        },
        act_people:''
    }
  },
  methods:{
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    onStateChange(){
      this.data.page = 1
      this.getList()
    },
    exportList(){
      if (!this.data.actid) {
        Message.error('活动信息缺失')
        return
      }
      const actid = encodeURIComponent(String(this.data.actid))
      const state = encodeURIComponent(String(this.data.state == null ? '0' : this.data.state))
      window.location.href = `http://jhyapi.softykt.cn/member/activity/activityUserExport?actid=${actid}&state=${state}`
    },
    appProClose(){
      this.appflow = false
      this.addsign = true
    },
    openAppli(row){
      console.log(row)
      let data={
        actid:row.act_id,
        userid:row.userid,
        from:row.from
      }
      this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/getUserJoinDetail",
            data
          ).then((res) => {
            if(res.data.code=='666'){
              this.arr = res.data.list
              this.arr.map(item=>{
                if(item.question_type=='2'){
                  let splice = item.choice.split(',')
                  item.splice = splice
                  console.log(item)
                }
                if(item.question_type=='6'){
                  let splice = item.choice.split(',')
                  item.splice = splice
                }
              })
            }
          })
      this.addsign = false
      this.appflow = true
    },
    //退票
    returnOrder(){
      MessageBox('此操作删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            
        }).catch(() => {
                 
        });
    },
    pxFn(row){
      this.data.actid = row.id
      this.data.state = '2'
      this.data.page = 1
      this.getList()
      this.addsign = true
    },
    getList(){
      this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/activityUser",
            {
              actid: String(this.data.actid),
              state: String(this.data.state || ''),
              limit: String(this.data.limit),
              page: String(this.data.page)
            }
          ).then((res) => {
            if(res.data.code=='666'){
                this.tableData = res.data.list || []
                this.total = res.data.count
                this.act_people = res.data.act_people
            } else {
              this.tableData = []
              this.total = 0
              this.act_people = 0
              if (res.data && res.data.msg) Message.error(res.data.msg)
            }
          })
    },
    addProClose(){
      this.addsign = false
      this.$emit('close')
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
  }
}
</script>
<style lang="less" scoped>
.title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.2rem;
  >div{
    font-size: 1.4rem;
    color: #000000;
    span{
      color: #000000;
      &:nth-child(1){
        font-family: OPPOSans;
      }
      &:nth-child(2){
        color: #246DEB;
      }
    }
  }
  .filter-row{
    display: flex;
    align-items: center;
    .filter-label{
      margin-right: 0.8rem;
      color: #333;
      font-size: 1.4rem;
    }
    .export-btn{
      margin-left: 1.2rem;
      background: #246DEB;
      border-color: #246DEB;
    }
  }
}
.table{
  margin-top: 1rem;
}
  // 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.button{
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  >div{
    cursor: pointer;
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    &:nth-child(1){
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246DEB;
      margin-left: 2rem;
    }
  }
}
.tab_detail{
  color: #246DEB;
  font-size: 1.4rem;
  cursor: pointer;
}
.box{
  width:87rem;
  background: #F9F9F9;
  border: 1px solid #E5E5EA;
  border-radius: 0.4rem;
  padding: 2rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 2rem;
  .box_title{
    display: flex;
    align-items: center;
    span{
      font-size: 1.4rem;
      color: #666666;
      span{
        color: #FF4D4F;
      }
    }
  }
  .box_radio{
    margin-left: 3rem;
    display: flex;
    flex-direction: column;
    margin-top: 1.7rem;
    >div{
      &:nth-child(1){
        margin-bottom: 2rem;
      }
    }
  }
  .box_select{
    display: flex;
    align-items: center;
    margin-top: 2rem;
    >div{
      margin-left: 3rem;
    }
  }
  .box_textares{
    margin-top: 2rem;
    margin-left: 2rem;
    width: 80rem;
    height: 4rem;
    background: #E5E5EA;
    border: 1px solid #E5E5EA;
    color: #666666;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    padding-left: 2rem;
    border-radius: 0.4rem;
  }
  .textarea_title{
    font-size: 1.4rem;
    color: #666666;
    display: block;
    margin: 1.5rem 0 0 2rem;
  }
}
.boxwhite{
  background: #F9F9F9;
  border: 1px solid #E5E5EA;
}
.slect_flex{
  justify-content: space-between;
  flex-wrap: wrap;
  display: flex;
  .el-select{
    margin-bottom: 2rem;
  }
}
::v-deep .el-checkbox-group{
  margin-bottom: 2rem;
}
.checkbox{
  >div{
      &:nth-child(1){
        margin-bottom:0 !important;
      }
    }
}
::v-deep .el-dialog__body{
    padding: 0px 20px 20px;
  }
  ::v-deep .el-divider--horizontal{
    margin: 0 0 20px 0;
  }
</style>